import { createAction, props } from '@ngrx/store';
import { CareAppListActionFactory } from '../action-factory';
import {
  ColorSettingsDto,
  FileRecordDto,
  OrganisationBrandingDto,
  OrganisationConfigDto,
  OrganisationDto,
  OrganisationPreferenceDto,
} from '@careapp-group/ng-sdk';

class OrganisationActions extends CareAppListActionFactory<OrganisationDto> {
  get REQUEST_OWN() {
    return `[${this.type}][Request] own`;
  }
  get RESPONSE_SUCCESS_OWN() {
    return `[${this.type}][Response][Success] own`;
  }
  get RESPONSE_FAIL_OWN() {
    return `[${this.type}][Response][Fail] own`;
  }
  get REQUEST_PREFERENCES() {
    return `[${this.type}][Request] Organisation Preferences`;
  }
  get RESPONSE_SUCCESS_PREFERENCES() {
    return `[${this.type}][Response][Success] Organisation Preferences`;
  }
  get RESPONSE_FAIL_PREFERENCES() {
    return `[${this.type}][Response][Fail] Organisation Preferences`;
  }
  get UPDATE_PREFERENCES() {
    return `[${this.type}][Request] Save Organisation Preferences`;
  }
  get SUCCESS_UPDATE_PREFERENCES() {
    return `[${this.type}][Response][Success] Save Organisation Preferences`;
  }
  get FAIL_UPDATE_PREFERENCES() {
    return `[${this.type}][Response][Fail] Save Organisation Preferences`;
  }
  get REQUEST_BRANDING() {
    return `[${this.type}][Request] Organisation Branding`;
  }
  get RESPONSE_SUCCESS_BRANDING() {
    return `[${this.type}][Response][Success] Organisation Branding`;
  }
  get RESPONSE_FAIL_BRANDING() {
    return `[${this.type}][Response][Fail] Organisation Branding`;
  }
  get UPDATE_BRANDING_COLORS() {
    return `[${this.type}][Request] Save Organisation Branding Colors`;
  }
  get RESET_BRANDING_COLORS() {
    return `[${this.type}][Request] Reset Organisation Branding Colors`;
  }
  get SUCCESS_UPDATE_BRANDING_COLORS() {
    return `[${this.type}][Response][Success] Save Organisation Branding Colors`;
  }
  get FAIL_UPDATE_BRANDING_COLORS() {
    return `[${this.type}][Response][Fail] Save Organisation Branding Colors`;
  }
  get UPDATE_BRANDING_IMAGE() {
    return `[${this.type}][Request] Save Organisation Branding Image`;
  }
  get REMOVE_BRANDING_IMAGE() {
    return `[${this.type}][Request] Remove Organisation Branding Image`;
  }
  get SUCCESS_UPDATE_BRANDING_IMAGE() {
    return `[${this.type}][Response][Success] Save Organisation Branding Image`;
  }
  get FAIL_UPDATE_BRANDING_IMAGE() {
    return `[${this.type}][Response][Fail] Save Organisation Branding Image`;
  }
  get NO_VALID_ORGANISATIONS() {
    return `[${this.type}][Fail] No Valid Organisations`;
  }
  get REQUEST_ALL_ORG_CONFIG() {
    return `[${this.type}][Request] All Organisation Configuration`;
  }
  get RESPONSE_SUCCESS_ALL_ORG_CONFIG() {
    return `[${this.type}][Response][Success] All Organisation Configuration`;
  }
  get RESPONSE_FAIL_ALL_ORG_CONFIG() {
    return `[${this.type}][Response][Fail] All Organisation Configuration`;
  }
  get REQUEST_ORG_CONFIG() {
    return `[${this.type}][Request] Organisation Configuration`;
  }
  get RESPONSE_SUCCESS_ORG_CONFIG() {
    return `[${this.type}][Response][Success] Organisation Configuration`;
  }
  get RESPONSE_FAIL_ORG_CONFIG() {
    return `[${this.type}][Response][Fail] Organisation Configuration`;
  }
  get UPDATE_ORG_CONFIG() {
    return `[${this.type}][Request] Save Organisation Configuration`;
  }
  get SUCCESS_UPDATE_ORG_CONFIG() {
    return `[${this.type}][Response][Success] Save Organisation Configuration`;
  }
  get FAIL_UPDATE_ORG_CONFIG() {
    return `[${this.type}][Response][Fail] Save Organisation Configuration`;
  }

  RequestOwn() {
    return { type: this.REQUEST_OWN };
  }

  ResponseSuccessOwn(payload: OrganisationDto[]) {
    return { type: this.RESPONSE_SUCCESS_OWN, payload };
  }

  ResponseFailOwn(payload: Error) {
    return { type: this.RESPONSE_FAIL_OWN, payload };
  }

  RequestPreferences() {
    return { type: this.REQUEST_PREFERENCES };
  }

  ResponseSuccessPreferences(payload: OrganisationPreferenceDto & { organisationId: string }) {
    return { type: this.RESPONSE_SUCCESS_PREFERENCES, payload };
  }

  ResponseFailPreferences(payload: any) {
    return { type: this.RESPONSE_FAIL_PREFERENCES, payload };
  }

  UpdatePreferences(payload: OrganisationPreferenceDto) {
    return { type: this.UPDATE_PREFERENCES, payload };
  }

  SuccessUpdatePreferences(payload: OrganisationPreferenceDto & { organisationId: string }) {
    return { type: this.SUCCESS_UPDATE_PREFERENCES, payload };
  }

  FailUpdatePreferences(payload: any) {
    return { type: this.FAIL_UPDATE_PREFERENCES, payload };
  }

  RequestBranding() {
    return { type: this.REQUEST_BRANDING };
  }

  ResponseSuccessBranding(payload: OrganisationBrandingDto & { organisationId: string }) {
    return { type: this.RESPONSE_SUCCESS_BRANDING, payload };
  }

  ResponseFailBranding(payload: any) {
    return { type: this.RESPONSE_FAIL_BRANDING, payload };
  }

  UpdateBrandingColors(payload: ColorSettingsDto) {
    return { type: this.UPDATE_BRANDING_COLORS, payload };
  }

  RequestResetBrandingColors() {
    return { type: this.RESET_BRANDING_COLORS };
  }

  SuccessUpdateBrandingColors(payload: OrganisationBrandingDto & { organisationId: string }) {
    return { type: this.SUCCESS_UPDATE_BRANDING_COLORS, payload };
  }

  FailUpdateBrandingColors(payload: any) {
    return { type: this.FAIL_UPDATE_BRANDING_COLORS, payload };
  }

  UpdateBrandingImage(payload: FileRecordDto) {
    return { type: this.UPDATE_BRANDING_IMAGE, payload };
  }

  RemoveBrandingImage(payload: FileRecordDto) {
    return { type: this.REMOVE_BRANDING_IMAGE, payload };
  }

  SuccessUpdateBrandingImage(payload: OrganisationBrandingDto & { organisationId: string }) {
    return { type: this.SUCCESS_UPDATE_BRANDING_IMAGE, payload };
  }

  FailUpdateBrandingImage(payload: any) {
    return { type: this.FAIL_UPDATE_BRANDING_IMAGE, payload };
  }
  NoValidOrganisations() {
    return { type: this.NO_VALID_ORGANISATIONS };
  }

  // If no organisationId is provided, the current organisation Id will be used.
  RequestOrgConfig(payload?: { organisationId?: string }) {
    return { type: this.REQUEST_ORG_CONFIG, payload };
  }

  ResponseSuccessOrgConfig(payload: OrganisationConfigDto & { organisationId: string }) {
    return { type: this.RESPONSE_SUCCESS_ORG_CONFIG, payload };
  }

  ResponseFailOrgConfig(payload: any) {
    return { type: this.RESPONSE_FAIL_ORG_CONFIG, payload };
  }

  // Retrieve org config for all organisations available
  RequestAllOrgConfig(payload?: { organisationId?: string }) {
    return { type: this.REQUEST_ALL_ORG_CONFIG, payload };
  }

  ResponseSuccessAllOrgConfig(payload: OrganisationConfigDto & { organisationId: string }) {
    return { type: this.RESPONSE_SUCCESS_ALL_ORG_CONFIG, payload };
  }

  ResponseFailAllOrgConfig(payload: any) {
    return { type: this.RESPONSE_FAIL_ALL_ORG_CONFIG, payload };
  }

  UpdateOrgConfig(payload: { organisationId: string; config: OrganisationConfigDto }) {
    return { type: this.UPDATE_ORG_CONFIG, payload };
  }

  SuccessUpdateOrgConfig(payload: OrganisationConfigDto & { organisationId: string }) {
    return { type: this.SUCCESS_UPDATE_ORG_CONFIG, payload };
  }

  FailUpdateOrgConfig(payload: any) {
    return { type: this.FAIL_UPDATE_ORG_CONFIG, payload };
  }

  InitOrganisation = createAction(`[${this.type}] Route to selected organisation`);
  InitTenant = createAction(`[${this.type}] Route to tenant`);

  constructor() {
    super(`Organisations`);
  }
}

export const Organisations = new OrganisationActions();
